/**
 * O que vai junto da mensagem, antes de enviar (pedido do Igor, 2026-10-28):
 * a foto e o vídeo aparecem em miniatura, como no WhatsApp; os outros arquivos
 * num cartão com o tipo, o nome e o tamanho. O × tira da mensagem.
 * As URLs locais (blob:) são liberadas quando o anexo sai ou a caixa fecha.
 */
import { useEffect, useMemo } from "react";

import { SIGLA_DO_TIPO, tamanhoLegivel } from "../../services/chat";
import { ICONE, Ic } from "./Icones";
import { tipoDoArquivo } from "./Midia";

export function PreviaDosAnexos({ arquivos, aoTirar }) {
  const itens = useMemo(
    () => arquivos.map((arquivo) => {
      const tipo = tipoDoArquivo(arquivo);
      const comImagem = tipo === "imagem" || tipo === "video";
      return { arquivo, tipo, url: comImagem && typeof URL.createObjectURL === "function" ? URL.createObjectURL(arquivo) : null };
    }),
    [arquivos],
  );
  useEffect(() => () => itens.forEach((i) => i.url && URL.revokeObjectURL(i.url)), [itens]);

  return (
    <div className="pchat-previa-anexos" aria-label="Anexos desta mensagem">
      {itens.map(({ arquivo, tipo, url }, i) => (
        <figure key={`${arquivo.name}-${i}`} className={`pchat-previa-anexo ${url ? "midia" : "arquivo"}`} title={`${arquivo.name} · ${tamanhoLegivel(arquivo.size)}`}>
          {url && tipo === "imagem" && <img src={url} alt={arquivo.name} />}
          {url && tipo === "video" && <video src={url} muted preload="metadata" />}
          {!url && (
            <>
              <span className={`tipo ${tipo}`}>{SIGLA_DO_TIPO[tipo] || "ARQ"}</span>
              <figcaption>
                <b>{arquivo.name}</b>
                <span>{tamanhoLegivel(arquivo.size)}</span>
              </figcaption>
            </>
          )}
          <button type="button" className="tirar" aria-label={`Tirar ${arquivo.name}`} onClick={() => aoTirar(i)}><Ic d={ICONE.x} size={12} /></button>
        </figure>
      ))}
    </div>
  );
}
